// extracted by mini-css-extract-plugin
export default {"fundStrategyModalDescription":"SnapshotStrategyModalDescription_fundStrategyModalDescription__VcVT6"};